export default __webpack_public_path__ + "static/media/error.6f34696a.svg";